<template>
  <div class="personinfo-card">

    <div class="card-title">
      <img class="icon" src="../icons/icon/奖励情况.png"  alt="">
      <span class="title">奖励情况</span>
      <!-- <span class="family-title-fontSize2" @click="add" v-show="addFlag">
        新增附件
      </span>
      <span class="family-title-fontSize2" v-show="addFlag2" @click="submit">
        保存
      </span> -->
      <div class="opt-right">
        <el-button @click="add" :disabled="isDisabled" type="primary" size="mini" ><i class="el-icon-plus el-icon--left"></i>新增</el-button>
      </div>
    </div>


    <div class="card-body">

      <div class="body-item" v-for="(formData, index) in formDatas" v-bind:key="index" >

          <div class="body-item-tools">
            <i class="el-icon-delete delete"  @click="removeData(formData.oid)" v-show="isDisabled==false" ></i>
          </div>

          <el-form
            :inline="true"
            :model="formData"
            ref="formData"
            class="form_data"
            label-width="100px"
            :rules="rules"
            :disabled="isDisabled"
            size="medium" >

            <el-form-item
              label="奖励时间"
              prop="awardtime" >
              <el-date-picker
                v-model="formData.awardtime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" >
              </el-date-picker>
            </el-form-item>


            <el-form-item
              label="奖励单位"
              prop="awardcorp" >
              <el-input
                v-model="formData.awardcorp" 
                :maxlength="120"
              />
            </el-form-item>

            <el-form-item label="奖励内容" 
              class="awardcorp-wrap"
              prop="content">
              <el-input 
                type="textarea" 
                style="width:810px;"
                v-model="formData.content"
                :maxlength="100" showWordLimit />
            </el-form-item>


          </el-form>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: {
    VOStatus: {
      type: String,
      default: () => {
        return 'view'
      }
    },
    formFlag: {
      type: Number,
      default: () => {
        return 1
      }
    }
  },
  data() {
    return {
      // 用户填写信息
      formDatas:[],
      formDataNew:[],
      rewardForm: {
        oid:0,
        awardtime: '',
        awardcorp: '',
        content: ''
      },
      id: 0,
      assinList: [], //赋值
      addNewList: [], //新增
      currentLiStyle: 0,
      flag: true,
      familyFlag: false,
      addFlag: true,
      addFlag2: false,
      rules: {
        awardcorp: [
          {
            required: true,
            message: '请输入奖励单位',
            trigger: 'blur'
          },
          // { max: 120, message: '不能超过120个字符', trigger: 'blur' }
        ],
        awardtime: [
          {
            type: 'string',
            required: true,
            message: '请选择奖励时间',
            trigger: 'change'
          }
        ],
        content: [
          { required: true, message: '请填写奖励情况', trigger: 'blur' },
          // { max: 2000, message: '不能超过2000个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 提交表单
    submit() {
      this.$refs['rewardForm'].validate(valid => {
        if (valid) {
          this.addFlag = !this.addFlag
          this.addFlag2 = !this.addFlag2
          this.familyFlag = !this.familyFlag
          this.flag = !this.flag
          this.assinList.push({
            awardtime:   {value:this.rewardForm.awardtime} ,
            awardcorp:   {value:this.rewardForm.awardcorp} ,
            content:  {value: this.rewardForm.content}
          })
          this.addNewList.push({
            awardtime: this.rewardForm.awardtime,
            awardcorp: this.rewardForm.awardcorp,
            content: this.rewardForm.content
          });
            // this.$refs['rewardForm'].resetFields()
        }
      })
    },
    //新增成员
    add() {
      
      let newOid = new Date().getTime();
      this.formDataNew.push(newOid);

      this.formDatas.push({
        oid: newOid,
        awardtime: '',
        awardcorp: '',
        content: ''
      });

    },
    removeData(oid) {
      this.formDatas = this.formDatas.filter(item => oid != item.oid);
      this.formDataNew = this.formDataNew.filter(item => oid != item);
    },
    clearFormData() {
      // 清理数据
      this.formDatas = [];
      this.formDataNew = [];

    },
    resetFormData() {
      // 重置数据
      if(!this.$refs.formData
        || !this.$refs.formData.length 
        || this.$refs.formData.length == 0) {
            return;
      }

      for(let index in this.$refs.formData) {
            this.$refs.formData[index].resetFields();
      }

    },
    formAllValidate(){
      // 表单验证
      return new Promise(function(resolve){
        

        if(!this.$refs.formData 
          || !this.$refs.formData.length 
          || this.$refs.formData.length == 0) {
            resolve({
              "type": "rewardInfo",
              'status': 'ok',
              'msg': '没有数据,验证通过'
            });
        }
        
        var validateAll = [];

        for(let index in this.$refs.formData) {
            validateAll.push(this.$refs.formData[index].validate());
        }

        Promise.all(validateAll).then((values) => {
          // console.log(values)
            resolve({
              "type": "rewardInfo",
              'status': 'ok',
              'msg': '验证通过'
            });
        }).catch((e) => {
            // console.log(e)
            resolve({
              "type": "rewardInfo",
              'status': 'fail',
              'msg': '【奖励情况】页签验证不通过'
            });
        });

      }.bind(this));
    },
    formGetValue() {
      // 页面获取值
      return this.formDatas.map(item => {
        if(this.formDataNew.includes(item.oid)) {
          item.oid = 0;
        }
        return item;
      });
    },
    setFormDatas(datas) {
      // 设置数据
      this.formDataNew = [];

      this.formDatas = datas.map(item => {

          var newItem = {};
          // rewardForm
          for(let k in this.rewardForm) {
            if(item[k]) {
              newItem[k] = item[k].key;
            }
          }
          return newItem;
      });
      
    },
    //  表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  mounted() {

  },
  computed: {
    isDisabled: function() {
      if(this.$props.VOStatus == 'view') {
        return true;
      } else if(this.$props.VOStatus == 'edit') {
        return false;
      } else if(this.$props.VOStatus == 'new') {
        return false;
      }
      return true;
    }

  }
  
}
</script>

<style lang="scss" scoped>

.personinfo-card {
  // line-height: 40px;
  width: 960px;
  margin-left: 14px;
  margin-right: 2px;
  .card-title {
    position: relative;

    // border-bottom: 1px solid #ebebeb;
    margin-bottom: 20px;

    .icon {
      display:inline-block;
      height:40px;
      vertical-align: middle;
    }

    .title {
      line-height: 40px;
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      color: #01539f;
      vertical-align: middle;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -12px;
      height: 1px;
      background: #ebebeb;
    }

    .opt-right {
      position: absolute;
      right: 12px;
      top: 0px;
      height: 40px;
      line-height: 40px;

      .el-button {
        border: none;
        border-radius: 0px;
      }
    }

  }


  .card-body {

    .body-item {
      border: 1px solid #eee;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 20px;
    }

    .body-item-tools {
      height: 30px;
      margin-bottom: 12px;

      .delete {
        float: right;
        margin-top: 6px;
        font-size: 18px;
        color: rgba(255,0,0,0.85);
        cursor: pointer;
      }

      .delete:hover {
        color: rgba(255,0,0);
      }

      .delete:active {
        opacity: 0.5;
      }

    }

    .form_data {

    }

  }



}


.form_data {
  
  .el-input {
      width: 350px;
  }

  .awardcorp-wrap {
    
    .el-textarea__inner {
      resize: none;
    }

  }

}

::v-deep .el-textarea__inner {
  // resize: none;
}

</style>
